/** @jsx jsx */
import { jsx } from '@emotion/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@airwallex/form-select';
import { components } from 'react-select';
import { IconOrganisation } from '@airwallex/glyphs';
import { grays } from '@airwallex/colors';
import { airTracker } from '@/utils/airTracker';
import { COMPONENT_NAME_V2 } from '@/app';
import { clientSetStorage, StorageKey } from '@/utils/localStorage';
import { LANGUAGE_OPTIONS } from '@/utils/language';

const Control = (
  { children, ...rest }: any // eslint-disable-line @typescript-eslint/no-explicit-any
) => (
  <components.Control {...rest}>
    <IconOrganisation height={12} width={12} color={grays[60]} />
    {children}
  </components.Control>
);

export const LanguageSelect: FC = () => {
  const { i18n } = useTranslation();
  const selectValue = LANGUAGE_OPTIONS.find((option) => option.value === i18n.language);

  return (
    <Select
      name="language"
      menuPlacement="top"
      menuPortalTarget={document.body}
      options={LANGUAGE_OPTIONS}
      isSearchable={false}
      components={{
        Control,
      }}
      styles={{
        control: (base: any) => ({
          ...base,
          border: 'none',
          outline: 'none',
          background: 'transparent',
          '&:hover': {
            background: 'transparent',
          },
        }),
        valueContainer: (base: any) => ({
          ...base,
          padding: 0,
          marginLeft: 4,
          width: 49,
        }),
        singleValue: (base: any) => ({
          ...base,
          color: grays[60],
          fontSize: 12,
          lineHeight: '18px',
        }),
        menu: (baseStyles: any) => ({
          ...baseStyles,
          minWidth: '170px',
          zIndex: 9999,
        }),
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
      onChange={(option: any) => {
        const language = option?.value;
        if (language) {
          i18n.changeLanguage(language);
          clientSetStorage(StorageKey.LANG_KEY, language);
          airTracker.info('changeLanguage', { component: COMPONENT_NAME_V2, language });
        }
      }}
      value={selectValue}
    />
  );
};

export default LanguageSelect;
